import { getMartech } from 'ctm-util-functions/lib/get';
import Immutable from 'immutable';

/**
 * Pulls out data from the quote state and builds a payload for GTM. Specific to car.
 * @param {Immutable.Map} quote A Car Quote
 * @param {Immutable.Map} state Greater app state
 * @returns {Immutable.Map}     A Car Quote payload shaped correctly for consumption by marketing
 */
const getCarJourney = (quote, state) => {
    const getInQuote = getMartech(quote);

    return Immutable.Map({
        contact: {
            firstName: getInQuote('form.applicant.firstName'),
            lastName: getInQuote('form.applicant.lastName'),
            phone: getInQuote('form.applicant.mobile') || getInQuote('form.applicant.phone'),
            email: getInQuote('form.applicant.email'),
            optInPrivacy: getInQuote('form.applicant.optInPrivacy'),
            optInEmail: getInQuote('form.applicant.optInEmail'),
            optInPhone: getInQuote('form.applicant.optInPhone')
        },
        address: {
            gnafId: getInQuote('form.coverDetail.overnightParking.address.gnafId'),
            streetNumber: getInQuote('form.coverDetail.overnightParking.address.streetNumber'),
            streetName: getInQuote('form.coverDetail.overnightParking.address.streetName'),
            postcode: getInQuote('form.coverDetail.overnightParking.address.postcode'),
            suburb: getInQuote('form.coverDetail.overnightParking.address.suburb'),
            state: getInQuote('form.coverDetail.overnightParking.address.state'),
            parkingType: getInQuote('form.coverDetail.overnightParking.parkingType')
        },
        data: {
            helpers: {
                isDisclaimerContentExpanded: getInQuote('form.helpers.isDisclaimerContentExpanded')
            },
            vehicle: {
                rego: getInQuote('form.coverDetail.vehicle.rego'),
                redbookCodeLong: getInQuote('form.coverDetail.vehicle.redbookCodeLong'),
                redbookCode: getInQuote('form.coverDetail.vehicle.redbookCode'),
                glassCode: getInQuote('form.coverDetail.vehicle.glassCode'),
                nviCode: getInQuote('form.coverDetail.vehicle.nviCode'),
                marketValue: getInQuote('form.coverDetail.vehicle.marketValue'),
                description: getInQuote('form.coverDetail.vehicle.description'),
                make: getInQuote('form.coverDetail.vehicle.make'),
                year: getInQuote('form.coverDetail.vehicle.year'),
                model: getInQuote('form.coverDetail.vehicle.model'),
                body: getInQuote('form.coverDetail.vehicle.body'),
                transmission: getInQuote('form.coverDetail.vehicle.transmission'),
                colour: getInQuote('form.coverDetail.vehicle.colour'),
                fuel: getInQuote('form.coverDetail.vehicle.fuel'),
                alarmFitted: getInQuote('form.coverDetail.vehicle.alarmFitted'),
                immobiliserFitted: getInQuote('form.coverDetail.vehicle.immobiliserFitted'),
                hasOtherAccessories: getInQuote('form.coverDetail.vehicle.hasOtherAccessories'),
                factoryOptions: getInQuote('form.coverDetail.vehicle.factoryOptions'),
                nonStandardAccessories: getInQuote('form.coverDetail.vehicle.hasOtherAccessories'),
                modified: getInQuote('form.coverDetail.vehicle.modified'),
                damaged: getInQuote('form.coverDetail.vehicle.damaged'),
                securityFeatures: getInQuote('form.coverDetail.vehicle.securityFeatures')
            },
            cover: {
                coverType: getInQuote('form.coverDetail.coverType'),
                requestedExcess: getInQuote('form.coverDetail.requestedExcess'),
                financeType: getInQuote('form.coverDetail.financeType'),
                useType: getInQuote('form.coverDetail.useType'),
                currentlyInsured: getInQuote('form.coverDetail.currentlyInsured'),
                previousInsurer: getInQuote('form.coverDetail.previousInsurer'),
                annualKilometres: getInQuote('form.coverDetail.annualKilometres'),
                ownsAnotherCar: getInQuote('form.coverDetail.ownsAnotherCar'),
                ownsHome: getInQuote('form.coverDetail.ownsHome'),
                hasYoungerDriver: getInQuote('form.coverDetail.hasYoungerDriver'),
                driverOption: getInQuote('form.coverDetail.driverOption'),
                dateCommencement: getInQuote('form.coverDetail.commencementDate'),
                driver: {
                    gender: getInQuote('form.coverDetail.driver.gender'),
                    dob: getInQuote('form.coverDetail.driver.dob'),
                    employmentStatus: getInQuote('form.coverDetail.driver.employmentStatus'),
                    licenceType: getInQuote('form.coverDetail.driver.licenceType'),
                    licenceAge: getInQuote('form.coverDetail.driver.licenceAge'),
                    anyPreviousClaims: getInQuote('form.coverDetail.driver.anyPreviousClaims'),
                    noClaimRating: getInQuote('form.coverDetail.driver.noClaimRating'),
                    firstName: getInQuote('form.coverDetail.driver.firstName'),
                    lastName: getInQuote('form.coverDetail.driver.lastName'),
                    claimsDetails: getInQuote('form.coverDetail.driver.claimsDetails')
                },
                youngestDriver: {
                    gender: getInQuote('form.coverDetail.youngestDriver.gender'),
                    dob: getInQuote('form.coverDetail.youngestDriver.dob'),
                    licenceType: getInQuote('form.coverDetail.youngestDriver.licenceType'),
                    licenceAge: getInQuote('form.coverDetail.youngestDriver.licenceAge')
                },
                passengersPayment: getInQuote('form.coverDetail.passengersPayment')
            },
            resultPageFilters: {
                displayMode: getInQuote('results.config.displayMode'),
                sortBy: getInQuote('results.config.sorting.sortBy'),
                frequency: getInQuote('results.config.filters.frequency'),
                available: getInQuote('results.config.filters.available'),
                initialised: getInQuote('results.config.filters.initialised'),
                fetchNewResults: getInQuote('results.config.filters.fetchNewResults'),
                currentFilterActions: getInQuote('results.config.filters.currentFilterActions'),
                selectedProductIds: getInQuote('results.config.filters.selectedProductIds'),
                requestedExcess: getInQuote('results.config.helpers.filters.requestedExcess'),
                coverType: getInQuote('form.coverDetail.coverType')
            }
        }
    });
};

export default getCarJourney;
